import React from 'react'

const ECACategoryComponent = ({
    categoryList,
    setCatClick,
    catClick,
    showSideCategories,
    setNewOne,
}: any) => {
    return (
        <div className="ecTabs">
            <div className="ecTabsInner">
                {categoryList && categoryList.map((item: any, index: any) => {
                    return (
                        <div
                            className={catClick.category_id === item.category_id ? "active categoryTabs" : "categoryTabs"}
                            key={index}
                            onClick={() => { setCatClick(item); setNewOne(1); }}
                        >
                            <p className="subInnerHeading">{item.category_name}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default ECACategoryComponent